import React from 'react';
import { PlmProgramDetailForm } from './plmProgram-detail-form';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

export const PlmProgramEdit: React.FC = () => {
  const { setTitle, setTitlePath } = useInjectableComponents();
  const isSmall = useIsSmallScreen();

  React.useEffect(() => {
    setTitle(
      isSmall ? 'Edit PLM Program' : 'Edit Peak Load Management Program',
    );
    setTitlePath('/plmPrograms');

    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath, isSmall]);

  return <PlmProgramDetailForm />;
};
